import React from 'react';
import './TopBar.css';

const TopBar = () => {
  return (
    <div className="top-bar">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-lg-4 col-md-12">
            <div className="logo">
              <a href="/">
                <img 
                  src="/img/flomatexs.jpg" 
                  alt="Logo"
                  style={{ width: '250px', height: '2500px', margin: '0px' }}
                />
              </a>
            </div>
          </div>
          <div className="col-lg-8 col-md-7 d-none d-lg-block">
            <div className="row">
              <div className="col-4">
                <div className="top-bar-item">
                  {/* Empty column for spacing */}
                </div>
              </div>
              <div className="col-4">
                <div className="top-bar-item">
                  <div className="top-bar-icon">
                    <i className="flaticon-call"></i>
                  </div>
                  <div className="top-bar-text">
                    <h3>Call Us</h3>
                    <p><a href="tel:+6590625963">+65 90625963</a></p>
                    <p><a href="tel:+353892348345">+353 896047510</a></p>
                    <p><a href="tel:+9104652207603">+91 8344390703</a></p>
                  </div>
                </div>
              </div>
              <div className="col-4">
                <div className="top-bar-item">
                  <div className="top-bar-icon">
                    <i className="flaticon-send-mail"></i>
                  </div>
                  <div className="top-bar-text">
                    <h3>Email Us</h3>
                    <a href="mailto:info@mikan-groups.com" target="_blank" rel="noopener noreferrer">
                      <i className="fas fa-envelope"></i> Click Here
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;